import { render, staticRenderFns } from "./case_success.vue?vue&type=template&id=edf57d3a&scoped=true"
import script from "./case_success.vue?vue&type=script&lang=js"
export * from "./case_success.vue?vue&type=script&lang=js"
import style0 from "./case_success.vue?vue&type=style&index=0&id=edf57d3a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf57d3a",
  null
  
)

export default component.exports